// NAAC UPLOAD FOR COLLEGE TEAM
export const storageAccount = process.env.REACT_APP_STORAGE_ACCOUNT // dbraeiassetmanagement
export const storageContainer = process.env.REACT_APP_STORAGE_CONTAINER //dbralcnaacsupdoc
export const storageSAS = process.env.REACT_APP_STORAGE_SAS //sv=2022-11-02&ss=bfqt&srt=co&sp=rwdlacupiytfx&se=2025-12-31T14:05:04Z&st=2025-01-24T06:05:04Z&spr=https&sig=h1DzgZSmeiqhuw%2BPK0xU0nEHdR4EM%2FzPDJf1E%2FQLF%2F0%3D
export const docViewURL = process.env.REACT_APP_DOC_VIEW_URL //"https://www.dbralc.edu.in/naacdocs/"
export const APP_MODE =
  process.env.REACT_APP_IS_DBRADC === 'true' ? 'DBRADC' : 'DBRALC'

//NAAC SUPPOPRTING DOCUMENTATION UPLOAD
export const websupdocs = process.env.REACT_APP_NAAC_DETAILS_URL
export const naacStorageContainer = process.env.REACT_APP_NAAC_STORAGE_CONTAINER
export const naacProductionFolder =
  process.env.REACT_APP_NAAC_STORAGE_PROD_FOLDER
export const naacDataFolder = process.env.REACT_APP_NAAC_STORAGE_NAAC_FOLDER
export const naacSupportingDocsFolder =
  process.env.REACT_APP_NAAC_STORAGE_SUPPORTINGDOCS_FOLDER
